/**
 * Builds the JSON-LD schema for breadcrumbs based on an array of breadcrumb objects.
 * https://developers.google.com/search/docs/appearance/structured-data/breadcrumb#structured-data-type-definitions
 * @param {Array} breadcrumbs
 * @param {string} origin url
 * @returns {Object|null}
 */
export function buildSeoBreadcrumbSchema(breadcrumbs, origin) {
  try {
    if (!breadcrumbs || !origin) {
      return;
    }

    const itemListElement = breadcrumbs.map((breadcrumb, index) => {
      if (!breadcrumb.category || !breadcrumb.url) {
        return;
      }

      return {
        "@type": "ListItem",
        "position": index + 1,
        "name": breadcrumb.category,
        "item": `${origin}${breadcrumb.url}`,
      };
    });

    // Build the BreadcrumbList schema
    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": itemListElement,
    };

    addBreadcrumbSchemaToDOM(schema);
  } catch (error) {
    window?.Sentry?.captureException("Error building BreadcrumbList schema:", error.message);
    return null;
  }
}

/**
 * Adds the schema JSON-LD for breadcrumbs to the DOM.
 * @param {Object} schema - The schema.org structured data.
 */
function addBreadcrumbSchemaToDOM(schema) {
  if (typeof window !== "undefined") {
    // Ensure the previous schema is removed before adding a new one
    // so we always have the latest
    removeBreadcrumbSchemaFromDOM();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "breadcrumb-schema";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }
}

/**
 * Removes the breadcrumbs schema from the DOM.
 */
function removeBreadcrumbSchemaFromDOM() {
  if (typeof window !== "undefined") {
    const schemaElement = document.getElementById("breadcrumb-schema");
    if (schemaElement) {
      schemaElement.remove();
    }
  }
}
